<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item :label="$t('账号')">
              <j-input :placeholder="$t('输入账号模糊查询')" v-model="queryParam.expectionUser"></j-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="$t('异常类型')">
              <j-dict-select-tag v-model="queryParam.expectionType" :placeholder="$t('请选择异常类型')" dictCode="account_exception" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <!-- <div class="table-operator" style="border-top: 5px"> -->
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">添加用户</a-button> -->
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('用户信息')">导出</a-button> -->
      <!--
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      -->
      <!-- <a-button type="primary" icon="hdd" @click="recycleBinVisible=true">回收站</a-button> -->
    <!-- </div> -->

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">

        <template slot="avatarslot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user"/>
          </div>
        </template>

        <span slot="action" slot-scope="text, record">
          <!-- <a @click="handleDetail(record)">详情</a> -->
          <a @click="handleRead(record)" v-if="record.readState != 1">{{ $t('已读') }}</a>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <AccountExceptionListModal ref="AccountExceptionListRef" @ok="modalFormOk" />

  </a-card>
</template>

<script>
  import {putAction,getFileAccessHttpUrl,postAction} from '@/api/manage';
  import {frozenBatch} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import JInput from '@/components/jeecg/JInput'
  import AccountExceptionListModal from './modules/AccountExceptionListModal'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
import { json } from 'mathjs';

  export default {
    name: "AccountExceptionList",
    mixins: [JeecgListMixin],
    components: {
      JInput,
      AccountExceptionListModal
    },
    data() {
      return {
        description: this.$t('这是账号异常页面'),
        queryParam: {},
        recycleBinVisible: false,
        url: {
          list: "/sys/userExpectionRecord/list",
          queryById: "/sys/userExpectionRecord/edit",
        },
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t, r, index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('异常账户'),
            align: "center",
            dataIndex: 'expectionUser',
            width: 120,
            ellipsis: true,
          },
          {
            title: this.$t('异常类型'),
            align: "center",
            width: 100,
            dataIndex: 'expectionType',
            ellipsis: true,
            customRender: (text) => {
              //字典值替换通用方法
              return filterDictTextByCache('account_exception', text);
            },
            // customRender:function (t,r,index) {
            //   if(t == 0){
            //     return '登录ip异常'
            //   }else if(t == 1){
            //     return '账号异常'
            //   }
            // }
          },
          {
            title: this.$t('异常客户端操作系统'),
            align: "center",
            width: 150,
            dataIndex: 'expectionOs',
            ellipsis: true,
          },
          {
            title: this.$t('异常ip'),
            align: "center",
            width: 100,
            dataIndex: 'expectionIp',
            ellipsis: true,
          },
          {
            title: this.$t('异常描述'),
            align: "center",
            dataIndex: 'expectionDescription',
            width: 200,
            ellipsis: true,
          },
          {
            title: this.$t('异常城市'),
            align: "center",
            width: 100,
            dataIndex: 'expectionCity',
            ellipsis: true,
          },
          {
            title: this.$t('地区码'),
            align: "center",
            width: 100,
            dataIndex: 'sysOrgCode',
            ellipsis: true,
          },
          {
            title: this.$t('异常浏览器'),
            align: "center",
            width: 150,
            dataIndex: 'expectionBrowser',
            ellipsis: true,
          },
          {
            title: this.$t('创建时间'),
            align: "center",
            width: 150,
            dataIndex: 'createTime',
            ellipsis: true,
          },
          {
            title: this.$t('状态'),
            align: "center",
            width: 80,
            dataIndex: 'readState',
            ellipsis: true,
            customRender: (t) => {
              if(t == 0){
                return this.$t('未读')
              }else if(t == 1){
                return this.$t('已读')
              }
            }
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 100
          }

        ]
      }
    },
    methods: {
      handleDetail(row){
        this.$refs.AccountExceptionListRef.init(row);
      },
      handleRead(row){
        let params = JSON.parse(JSON.stringify(row));
        params.readState = 1;
        postAction(this.url.queryById,params).then(res => {
          if(res.success){
            this.$message.success(res.message);
            this.loadData();
          }
        });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>